import { createContext, ReactNode, useContext, useEffect } from "react"
import { getNavigation, getPolicy } from "../../utils"
import { useQuery } from "@tanstack/react-query"
import { NavigationsPublic, PolicyPublic } from "../../client"
import { Center, Spinner } from "@chakra-ui/react"

type SettingsContextValue = {
  policy: PolicyPublic | undefined
  navigationPoints: NavigationsPublic | undefined
}
const SettingsContext = createContext<SettingsContextValue | null>(null)


export function SettingsProvider({ children }: { children: ReactNode }) {
    const {data: policy, isLoading: isLoadingPolicy } = useQuery(getPolicy())
    const {data: navigationPoints, isLoading: isLoadingNav } = useQuery(getNavigation())

    // Apply CSS variables for theme colors
    useEffect(() => {
        const root = document.documentElement
        if(policy?.main_color) root.style.setProperty(`--main`, policy.main_color)
        if(policy?.secondary_color) root.style.setProperty(`--secondary`, policy.secondary_color)
        if(policy?.tertiary_color) root.style.setProperty(`--tertiary`, policy.tertiary_color)
    }, [policy])

    if (isLoadingPolicy || isLoadingNav) return (
        <Center
            position="fixed"
            top="0"
            left="0"
            width="100vw"
            height="100vh"
            zIndex="10000"
            pointerEvents="none"
        >
            <Spinner size="lg" color="main" />
        </Center>
    )

    return (
        <SettingsContext.Provider value={{ policy, navigationPoints }}>
            {children}
        </SettingsContext.Provider>
    )
}

export function useSettings() {
    return useContext(SettingsContext)
}